module.exports = __webpack_public_path__ + "img/carta-s.46ebbe7.svg";